import React, { useCallback } from "react";

import { readState } from "@/__main__/app-state.mjs";
import MenuListItem from "@/app/AppShellMenuListItem.jsx";
import { LOGIN, LOGOUT } from "@/feature-auth/constants/constants.mjs";
import * as AuthActions from "@/feature-auth/utils/auth-actions.mjs";
import { classNames } from "@/util/class-names.mjs";
import { useSnapshot } from "@/util/use-snapshot.mjs";

export default function SignInOutButton({ className, onClick }) {
  const state = useSnapshot(readState);

  const handleLogout = useCallback(() => {
    AuthActions.logoutUser();
    onClick?.();
  }, [onClick]);

  if (state.user) {
    return (
      <MenuListItem
        text={LOGOUT.text}
        onClick={handleLogout}
        {...classNames(className)}
      />
    );
  }

  return (
    <MenuListItem {...LOGIN} onClick={onClick} {...classNames(className)} />
  );
}
